import HomeContainer from "./containers/HomeContainer";
import ZipContainer from "./containers/ZipContainer";
import SinglePathContainer from "./containers/SinglePathContainer";
import DoublePathContainer from "./containers/DoublePathContainer";

const ROOT_PATH = "/branchlocations";

// appStates have to do with routing, vs regionStates which are Texas, etc
const appStates = [
    { name: "home", url: `${ROOT_PATH}`, component: HomeContainer },
    { name: "home2", url: `${ROOT_PATH}/`, component: HomeContainer },
    {
        name: "singlePath",
        url: `${ROOT_PATH}/:singlePath`,
        component: SinglePathContainer
    },
    {
        name: "zip",
        url: `${ROOT_PATH}/zip/:zip`,
        component: ZipContainer
    },
    {
        name: "doublePath",
        url: `${ROOT_PATH}/:firstPath/:secondPath`,
        component: DoublePathContainer
    }
];

export default appStates;



// WEBPACK FOOTER //
// ./appStates.js